import * as vp from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useFetchPartnerAccoutPermissionFields(bearer: string) {
  const source = axios.CancelToken.source();
  const [, setPending] = useDataFetchIndicator();

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchAccountPermissionFields(params: vp.PartnerAccountPermissionRequest) {
    try {
      setPending(true);
      const res = await api.fetchPartnerAccountPermissionFields(params, bearer, source);

      return res;
    } finally {
      setPending(false);
    }
  }

  return {
    fetchAccountPermissionFields,
  };
}
